<div class="widget-container" #GroupHBar>
    <app-grouped-hbar-chart 
    style="width: 100%;"
    [headerConfig]="this.item.config.widget_header_config"
    [config]="config"
    [heading]="heading" 
    [data]="data"  
    [item]="item"
    [pageKey]="pageKey"
    [error_name]="error_name"
    [prefrenceConfig]="prefrenceConfig"
    >
    </app-grouped-hbar-chart>
</div>
